import { Assets, ParsedHtmlContent, SpeechBubble } from '@foradevelopment/fora-ui';

import { useAppSelector } from '../../redux/hooks';

export const FileDashBoardFirstVisitMessage = () => {
  const ingressNoReports = useAppSelector(state => state.content.content.ingressFileDashboardNoReports);
  return (
    <SpeechBubble color="babyBlue" illustration={<Assets.InfoBubbleIllustration width={34} />}>
      <ParsedHtmlContent
        htmlContent={ingressNoReports ? ingressNoReports.body : ''}
        styling={{ h5: { marginBottom: 6 }, p: { marginBottom: 20 } }}
      />
    </SpeechBubble>
  );
};
